export enum DefectPriority {
    high = 2,
    medium = 3,
    low = 5
}